import React from "react";
import "./style.css";
const ImageLoader = ({ src, className }) => {
  const [isImageLoading, setIsImageLoading] = React.useState(true);

  React.useEffect(() => {
    setIsImageLoading(true);
  }, [src]);

  React.useEffect(() => {
    const time = localStorage.getItem("datetime-scroll-position")
    if (((new Date()).getTime() - time) < (10 * 60 * 1000)) {
      setIsImageLoading(false)
    }
  }, []);


  return (
    <div className="image-loader">
      {isImageLoading && (
        <div className={className}>
          <div className="loader">
            <div className="spinner"></div>
            <div className="loader-text">Loading image...</div>
          </div>
        </div>
      )}
      <div
        style={{
          backgroundImage: `url('${src}')`,
          backgroundSize: "cover",
          backgroundPosition: "left",
          backgroundRepeat: "no-repeat",
          display: isImageLoading ? "none" : "block",
        }}
        className={className}
      />
      <img
        src={src}
        alt=""
        style={{ display: "none" }}
        onLoad={function (event) {

          setIsImageLoading(false)
        }}
      />
    </div>
  );
};

export default ImageLoader;
